import { useEffect, useState } from "react";
import axios from "axios";
import { Pencil } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EDIT_ROLES = ["super_admin", "tenant_admin", "admin", "manager"];
let mePromise = null;
const getMe = () => (mePromise ||= axios.get(`${API}/auth/me`).then((r) => r.data).catch(() => (mePromise = null)));

export const EditableComment = ({ leadId, action, onSaved }) => {
  const [me, setMe] = useState(null);
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(action.text || action.notes || "");
  const [saving, setSaving] = useState(false);
  useEffect(() => { getMe()?.then(setMe); }, []);
  const canEdit = me && (me.email === action.user_email || EDIT_ROLES.includes(me.role));
  const tid = `comment-${action.date}`;

  const save = async () => {
    if (!text.trim()) return toast.error("Comment can't be empty");
    setSaving(true);
    try {
      await axios.patch(`${API}/leads/${leadId}/comments`, { date: action.date, user_email: action.user_email, text });
      toast.success("Comment updated");
      setEditing(false);
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't update comment");
    } finally { setSaving(false); }
  };

  if (editing) return (
    <div className="mt-2 space-y-2">
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} autoFocus
        className="w-full text-sm border border-[#1F8A7C]/30 rounded p-2 focus:outline-none focus:ring-2 focus:ring-[#1F8A7C]/40" data-testid={`${tid}-input`} />
      <div className="flex gap-2">
        <button onClick={save} disabled={saving} className="px-3 py-1 text-xs font-semibold rounded bg-[#1F8A7C] hover:bg-[#18705F] text-white disabled:opacity-50" data-testid={`${tid}-save`}>{saving ? "Saving…" : "Save"}</button>
        <button onClick={() => { setEditing(false); setText(action.text || action.notes || ""); }} className="px-3 py-1 text-xs font-semibold rounded border border-gray-300 text-gray-700 hover:bg-gray-50" data-testid={`${tid}-cancel`}>Cancel</button>
      </div>
    </div>
  );
  return (
    <div className="group mt-2 flex items-start gap-2 bg-white p-2 rounded">
      <p className="text-sm text-gray-700 flex-1 whitespace-pre-wrap" data-testid={`${tid}-text`}>
        {action.text || action.notes}
        {action.edited_at && <span className="ml-2 text-[11px] text-gray-400 italic" title={`Edited by ${action.edited_by}`} data-testid={`${tid}-edited`}>edited · {new Date(action.edited_at).toLocaleString()}</span>}
      </p>
      {canEdit && <button onClick={() => setEditing(true)} title="Edit comment" className="text-gray-400 hover:text-[#1F8A7C] transition-colors" data-testid={`${tid}-edit`}><Pencil className="h-3.5 w-3.5" /></button>}
    </div>
  );
};
